export const updateHeight = (height: number) => {
  return {
    type: "UPDATE_HEIGHT",
    height,
  }
}
